import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner' 

// navigation
import Nav from 'react-bootstrap/Nav';

// icons
import { IoMdArrowRoundForward } from 'react-icons/io';


const CustomButton = (props) => {
    return (
        <>
        { props.link ?
            <Nav.Link href={props.link}>
                <Button 
                    variant={props.variant ? props.variant : 'primary'}
                    onClick={props.onClick}
                    icon={props.icon}
                    style={{
                        fontSize:16,
                        width:180,
                        borderRadius:5
                    }}>{props.children}</Button>
            </Nav.Link>
        :
            props.status == 'loading' ?
            <Button 
                variant={props.variant ? props.variant : 'primary'}
                onClick={props.onClick}
                style={{
                    fontSize:16,
                    width:180,
                    borderRadius:5  
                }}>
                        <Spinner
                            as="span"
                            animation="border"
                            role="status"
                            aria-hidden="true"
                            variant="light"
                            size="sm"
                        />
                </Button>
            :
            <Button 
                variant={props.variant ? props.variant : 'primary'}
                onClick={props.onClick}
                style={{
                    fontSize:16,
                    width:180,
                    borderRadius:5  
                }}>{props.children}</Button>
        }
        </>
    );
};

const Icon = (props) => {
    return (
        <div className='mt-4'>
            <Nav.Link href={props.link}>
                <Button 
                    variant={props.variant ? props.variant : 'primary'}
                    onClick={props.onClick}
                    style={{
                        fontSize:16,
                        width:180,
                        borderRadius:5
                    }}>{props.children}</Button>
                    <IoMdArrowRoundForward size={16} color={'#307FE2'} style={{marginLeft:6, marginTop:-2}} />    
            </Nav.Link>
        </div>
    )
}

const Tag = (props) => {
    return (
        <>
        { props.link ? 
        <Nav.Link href={props.link}>
            <div 
                onClick={props.onClick}
                style={{
                    cursor:'pointer',
                    fontSize:12,
                    fontWeight:'500',
                    borderRadius:5,
                    textAlign:'center',
                    paddingLeft:4, paddingRight:4, 
                    backgroundColor: props.backgroundColor ? props.backgroundColor : '#Dee1e2'
                }}>{props.children}</div>
        </Nav.Link>
        :
        <div 
            onClick={props.onClick}
            style={{
                cursor:'pointer',
                fontSize:12,
                fontWeight:'500',
                borderRadius:5,
                textAlign:'center',
                paddingLeft:4, paddingRight:4, 
                backgroundColor: props.backgroundColor ? props.backgroundColor : '#Dee1e2'
            }}>{props.children}</div>
        }
        </>
    );
};

CustomButton.CustomButton= CustomButton;
CustomButton.Tag = Tag;
CustomButton.Icon = Icon;

export default CustomButton;